<template>
  <div class="news">
    <van-pull-refresh  v-model="isLoading" @refresh="refresh">
      <van-list class="list" v-model="isLoading" :finished="isFinished || isError" @load="getList">
        <router-link v-for="item in list" :to="'/article/detail/' + item.id">
          <card-news :news="item" :key="item.id"/>
          <!-- <card-gallery :card="item" class="van-hairline--bottom" v-else></card-gallery> -->
        </router-link>
        <list-foot v-if="isFinished"></list-foot>
        <list-foot v-if="isError" @click.native="getList">出错了</list-foot>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
  import {getArticleList} from '@/api/common'
  import CardNews from '@/components/CardNews'
  import CardGallery from '@/components/CardGallery'

  import ListFoot from '@/components/ListFoot'
  import {PullRefresh, List} from 'vant'

  export default {
    name: 'ExhibitionNews',

    components: {
      [PullRefresh.name]: PullRefresh,
      [List.name]: List,
      CardNews, 
      ListFoot, 
      CardGallery
    },

    data() {
      return {
        list: [],
        page: 1,
        isLoading: false,
        isFinished: false,
        isError: false,
      }
    },
   
    methods: {
      async getList() {
        this.isFinished = false
        this.isLoading = true

        let list = await getArticleList('news', this.page).catch(() => {
          this.isLoading = false
          this.isError = true
          this.isFinished = true;
        })

        this.isLoading = false

        if(list.length < 20) {
          this.isFinished = true
        }

        if(this.page === 1) {
          this.list = list;
        } else {
          this.list = [...this.list, ...list]
        }

        this.page += 1
      },

      async refresh() {
        this.page = 1
        this.getList()
      },
      
    },

    // deactivated() {
    //   this.isLoading = false
    // },

    created() {
      this.getList()
    }
  }
</script>

<style scoped lang="less">
 
  .news{
    background-color: #fff;
  }
</style>